const actionScope = '[K365 Setup Guides Access]';

export class LoadK365SetupGuidesAccessIfNotLoaded {
  static readonly type = `${actionScope} Load K365 Setup Guides Access If Not Loaded`;
}

export class SetK365SetupGuidesAccessInactive {
  static readonly type = `${actionScope} Set K365 Setup Guides Access Inactive`;
}
